import ManualDataUploader from '../../components/ManualDataUploader/ManualDataUploader';
import PageLayout from '../../wrappers/PageLayout';
import { Loader } from '../../components/Loader/Loader';
import Integrations from '../../components/Integrations/Integrations';
import { useSellerIntegrations } from '../../context/integrations-context';
import SellerManualUploadInstructionBlock from '../../components/SellerManualUploadInstructionBlock/SellerManualUploadInstructionBlock';
import './SellerDataFiles.scss';
import { useMU } from '../../context/mu-context';
import { useQuery } from 'react-query';
import { useAppSelector } from '../../hooks';
import { getEasybillTokenStatus } from '../../core/api';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function SellerDataFiles() {
  const { vs3776BillbeeToken } = useFlags();
  const { isLoading, integrations } = useSellerIntegrations();
  const { isLoadingMU } = useMU();

  const user = useAppSelector((s) => s.user.user);
  const activeCompany = useAppSelector((s) => s.user.activeCompany);

  const { data: easybillData, isLoading: isLoadingEasybill } = useQuery(
    ['SellerEasybill', user!.Id, activeCompany?.company_id],
    () => getEasybillTokenStatus(activeCompany?.company_id)
  );

  return (
    <PageLayout
      className='flex-grow-1'
      rightColumn={
        <div style={{ maxWidth: 328 }} className='ms-lg-auto pt-3 pt-lg-0'>
          <SellerManualUploadInstructionBlock />
          <div className='Paper ms-auto pb-3 pt-2 px-3 mb-3'>
            {(integrations ||
              vs3776BillbeeToken ||
              activeCompany?.EasybillClient) && (
              <Integrations
                integrations={integrations}
                easybillData={easybillData}
              />
            )}
          </div>
        </div>
      }
    >
      <div>
        {(isLoading || isLoadingMU || isLoadingEasybill) && <Loader />}
        <ManualDataUploader />
      </div>
    </PageLayout>
  );
}
